import { render, staticRenderFns } from "./BundledItemsDetails.vue?vue&type=template&id=0c3fdd39&"
import script from "./BundledItemsDetails.vue?vue&type=script&lang=js&"
export * from "./BundledItemsDetails.vue?vue&type=script&lang=js&"
import style0 from "./BundledItemsDetails.vue?vue&type=style&index=0&id=0c3fdd39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports